import { GAME_CONSTANTS } from '../config/gameConstants';

/**
 * Type-safe dashboard tab names derived from game constants
 */
export type DashboardTab = typeof GAME_CONSTANTS.dashboard.tabs[number];

/**
 * Constant object for type-safe tab references
 */
export const DASHBOARD_TABS = {
  HEADQUARTERS: 'Headquarters',
  PRODUCTS: 'Products',
  OPERATIONS: 'Operations',
  RESEARCH: 'Research',
  MARKETING: 'Marketing',
  FINANCE: 'Finance',
  CALENDAR: 'Calendar',
  COMPANY: 'Company',
} as const satisfies Record<string, DashboardTab>;
